export const RESOURCES_PICKER = {
  DIALOG: 'resources-picker-dialog',
  POPPER: 'resources-picker-popper',
  SEARCH_CLEAR_BUTTON: 'resources-picker-search-clear-button',
  SEARCH_ICON: 'resources-picker-search-icon',
  INFO_MESSAGE_CLOSE: 'resources-picker-info-message-close',
  RESOURCES_LIST: 'resources-picker-resources-list',
  CREATE_RESOURCE_BUTTON: 'resources-picker-create-resource-button'
} as const;
